import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AssetBreadcrumb } from '../../../../../../../../../../../features/asset/asset-breadcrumb';
import { AssetLogoBreadcrumb } from '../../../../../../../../../../../features/asset/logo/asset-logo-breadcrumb';
import { INVENTORY_TRADING_DAY_BASE_PATH } from '../../../../../../../../../../../features/inventory/trading-day/inventory-trading-day-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day/$assetId/_$assetId',
)({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `inventory-trading-day-asset-${params.assetId}`,
        label: <AssetBreadcrumb assetId={params.assetId} />,
        prefix: <AssetLogoBreadcrumb assetId={params.assetId} />,
        to: INVENTORY_TRADING_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
